import moment from 'moment';

var getLocalDateTime = function (dts) {
    if (dts == null) return null;
   if (dts == "") return new Date(1970, 0, 1);
   
   let time;

   if(dts instanceof Date){
       time = dts;
   }else{       
       time = moment(dts).toDate();
   }    

   time.setMinutes(time.getMinutes() - this.timeZoneOffsetMinutes);
   return time;
}

export default getLocalDateTime;


// WEBPACK FOOTER //
// ./app/local-time.js